import * as Sentry from "@sentry/react";
import {useEffect} from "react";
import {createRoutesFromChildren, matchRoutes, useLocation, useNavigationType} from "react-router-dom";

function getEnvironmentName() {
    if (window.location.hostname === "localhost") {
        // get environment variable
        const DEVELOPER_NAME = import.meta.env.REACT_APP_DEVELOPER_NAME
        return `local (${DEVELOPER_NAME})`
    }
    return "production"
}
function initSentry(){
    if (window.location.hostname === "localhost") {
        // @ts-expect-error "desired behavior"
        console.log("disabled sentry on localhost")
        return
    }
    Sentry.init({
        dsn: "https://1ce0e2832a8330ca4e480f160792518d@o4507816790458368.ingest.us.sentry.io/4508215229874176",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect: useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            })
        ],
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        tracePropagationTargets: ["api.veilstream.com", "localhost:2000"],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        environment: getEnvironmentName(),
    });
}

const sentryMiddleware = async (next, request) => {
    try {
        const response = await next(request);
        return response;
    } catch (error) {
        // Capture the error and send it to Sentry
        Sentry.captureException(error, {
            extra: {
                request: {
                    url: request.url,
                    method: request.method,
                    body: request.body,
                },
                response: error.response ? {
                    status: error.response.status,
                    data: error.response.data,
                } : null,
            },
        });
        throw error; // Re-throw after logging
    }
};

export {sentryMiddleware};
export default initSentry;
